import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import styled, { css } from 'styled-components'
import { TextWidth } from '@ta-interaktiv/react-disco-grid'
import { GlobalVariables } from 'Globals/GlobalVariables'
import { SwissMap } from 'components/ChoroplethMap'
// import chTopoJson from '../ChoroplethMap/Assets/ch_map.json'
import chTopoJson from '../ChoroplethMap/Assets/ch_mapSimplified52.json'
import data from '../ChoroplethMap/Assets/mieten_gemeinden.json'
import MapControls from 'components/MapControls'
import { useContext, useEffect, useRef, useState } from 'react'
import { COLOR_PALLETTE, ROOM_SIZE_NAMES } from 'Globals/Constants'
import ToolTip from 'components/ToolTip/ToolTip'
import ColorLegend from 'components/ColorLegend/ColorLegend'
import GlobalContext from 'Contexts/GlobalContext'
import { de, fr } from 'Globals/Locale'
// const muniTopoJson = chTopoJson[2]
// console.log({chTopoJson, muniTopoJson});

const MainComponent = ({
  tenant,
  colorMode,
  properties,
}: MicroFrontendProps) => {
  const [size, setSize] = useState(2)
  const [price, setPrice] = useState(2)
  const [activeMunicipalityId, setActiveMunicipalityId] = useState<number>()
  const [isFullscreen, setIsFullscreen] = useState<boolean>(false)
  const [foundMunicipalityFromUrl, setFoundMunicipalityFromUrl] = useState(false)
  ToolTip.defaultProps = { currentRoomSize: ROOM_SIZE_NAMES[size] }
  ToolTip.defaultProps = { currentPrice: price }
  const activeMunicipality = data.find(
    (muni) => muni.bfsId === activeMunicipalityId
  )
  console.log({ activeMunicipality, activeMunicipalityId })

  const currentPrices = activeMunicipality?.[ROOM_SIZE_NAMES[size]] as number[]
  const numberOfAvailableFlats = currentPrices?.[currentPrices.length - 1]
  const numberOfFlatsForSelectedOptions = currentPrices?.[price]
  const currentLocale = tenant?.lang === 'fr' ? fr : de
  // useEffect(() => {
  //   if (activeMunicipalityId) {
  //     // if its a district in zurich set 261 as active municipality
  //     const newId = activeMunicipalityId > 3000 ? 26101 : activeMunicipalityId
  //     const newBfsIdEvent = new CustomEvent('changeGDE', {
  //       detail: newId,
  //     })
  //     console.log('🚀 Sending GDE-Change')
  //     window.dispatchEvent(newBfsIdEvent)
  //     // updateBfsIdInURL(selectedMunicipality.bfsId.toString())
  //   }
  // }, [activeMunicipalityId])

  useEffect(() => {
    // Get params from URL and set active municipality
    const searchParams = new URL(String(window.location)).searchParams
    const muniParam = searchParams.get(currentLocale.bfsIdParamName)
    const bfsIdFromUrl = muniParam && parseInt(muniParam)

    if (bfsIdFromUrl) {
      setFoundMunicipalityFromUrl(true)
      console.log('🔍 Found municipality from URL', bfsIdFromUrl)
      // if its Zürich set Kreis 1 as active municipality
      if (+bfsIdFromUrl === 261) {
        setActiveMunicipalityId(26101)
      } else {
        setActiveMunicipalityId(+bfsIdFromUrl)
      }
    }

    const handleEvent = (event: CustomEvent) => {
      console.log('📫 GDE-Change received')
      const newBfsId = event.detail
      newBfsId && setActiveMunicipalityId(newBfsId)
    }
    window.addEventListener('changeGDE', handleEvent as EventListener)

    const buttonUp = document?.querySelector('[class*=BackToTop_root]')
    buttonUp?.setAttribute('style', 'opacity: 0')
    return () => {
      window.removeEventListener('changeGDE', handleEvent as EventListener)
    }
  }, [])
  useEffect(() => {
      activeMunicipalityId && foundMunicipalityFromUrl && setFoundMunicipalityFromUrl(false)
  }, [activeMunicipalityId])
  return (
    <AppContainer $colorMode={colorMode}>
      <GlobalContext.Provider
        value={{ tenant, colorMode, properties, locale: currentLocale }}
      >
        {chTopoJson && (
          <MapSection>
            <MapControls
              size={size}
              setSize={setSize}
              price={price}
              setPrice={setPrice}
            />

            <SwissMap
              // LegendComponent={
              // ()=><StripedLegend>
              //   <StripedBox />
              //   {currentLocale.fewOffers}
              // </StripedLegend>}
              zoomIntoActiveMunicipality={true}
              locale={tenant.lang}
              propertyNameToCompare={ROOM_SIZE_NAMES[size]}
              indexOfPropertyToCompare={price}
              municipalityData={data}
              minValue={0}
              maxValue={1}
              topoJsonYear={0}
              topoJson={chTopoJson}
              colorPalette={COLOR_PALLETTE}
              currentPrice={price}
              currentRoomSize={ROOM_SIZE_NAMES[size]}
              newActiveMunicipalityIdHandler={(muniId) => {
                console.log('newActiveMunicipalityIdHandler', muniId)
                setActiveMunicipalityId(muniId)
              }}
              municipalitySearchYear={'20220101'}
              activeMunicipalityId={activeMunicipalityId}
              ToolTip={ToolTip}
              isFullscreen={isFullscreen}
              fullscreenChangeHandler={(isFullscreenNewVal) => {
                setIsFullscreen(isFullscreenNewVal)
              }}
              scrollIntoView={!foundMunicipalityFromUrl}
            />

            <ColorLegendWrapper>
              <ColorLegend
                colorPalette={COLOR_PALLETTE}
                customLabels={[
                  '0% ' + currentLocale.inBudget,
                  '50%',
                  '100% ' + currentLocale.inBudget,
                ]}
                numberOfTicks={3}
                minVal={0}
                maxVal={100}
                currentValue={
                  numberOfAvailableFlats
                    ? (+numberOfFlatsForSelectedOptions /
                        numberOfAvailableFlats) *
                      100
                    : undefined
                }
              />
            </ColorLegendWrapper>
            {activeMunicipality && (
              <>
                <ToolTipWrapper isFullscreen={isFullscreen}>
                  <ToolTip
                    currentRoomSize={ROOM_SIZE_NAMES[size]}
                    currentPrice={price}
                    activeData={activeMunicipality}
                    closePressed={() => setActiveMunicipalityId(undefined)}
                    isClosable
                    hasShadow={!isFullscreen}
                  />
                </ToolTipWrapper>
              </>
            )}
          </MapSection>
        )}
      </GlobalContext.Provider>
    </AppContainer>
  )
}
const ToolTipWrapper = styled.div<{ isFullscreen: boolean }>`
  pointer-events: none;
  z-index: 102;
  ${({ isFullscreen }) =>
    isFullscreen &&
    css`
      /* @media (max-width: 768px) { */
      left: 0.5em;
      right: 0.5em;
      position: sticky;
      bottom: 3.5em;
      /* } */
    `}
`
const StripedLegend = styled.div`
  display: flex;
  align-items: center;
  margin: 0 1em;
  margin-bottom: 1em;
  font-size: 0.75em;
  font-family: var(--font-sans-serif);
  color: var(--text-color);
`
const StripedBox = styled.div`
  width: 1.5em;
  height: 1.5em;
  background-image: repeating-linear-gradient(
    -45deg,
    var(--selection-background),
    var(--selection-background) 2px,
    var(--text-color) 2px,
    var(--text-color) 4px
  );
  opacity: 0.5;
  margin-right: 0.5em;
`
const ColorLegendWrapper = styled.div`
  padding: 0 1em;
  overflow: hidden;
`
const MapSection = styled.section`
  max-width: 1200px;
  margin: 0 auto;
  margin-bottom: 3rem;
  @media (min-width: 768px) {
    min-height: 523px;
  }
  #swiss-choropleth-map {
    path {
      transition: fill 0.5s cubic-bezier(0.645, 0.045, 0.355, 1);
    }
    svg {
      #country-border {
        /* fill: url(#diagonalHatch); */
        vector-effect: non-scaling-stroke;
      }
      .active-municipality {
        stroke: white;
        stroke-width: 2px;
      }
      .municipality {
        // only hover on desktop
        @media (hover: hover) {
          &:hover {
            stroke: white;
            stroke-width: 1.5px;
          }
        }
      }
    }
  }

  .municipality-search {
    margin-bottom: 2em;
    padding: 0 1em;
    svg {
      stroke: var(--text-color) !important;
    }
    #search {
      font-size: 18px;
      background-color: var(--selection-background);
      color: var(--text-color);
    }
    .results {
      overflow: hidden;
      z-index: 102;
      @media (min-width: 768px) {
        position: absolute;
      }
      display: flex;
      .result {
        max-width: 100%;
        background-color: var(--selection-background);
        color: currentColor;
      }
      flex-direction: column;
      pointer-events: auto;
      background-color: none;
    }
  }
`
const AppContainer = styled(TamediaStyles)`${GlobalVariables}
  background-color: var(--map-background-color);
  font-family: var(--font-sans-serif);
  font-size: 1.8rem;
  line-height: 3rem;
  padding: 1em 0;
  margin: 4rem 0;
  touch-action: pan-x pan-y;
`
export default MainComponent
